module.exports = __webpack_public_path__ + "static/skyward-harp-8aa96702753af38dacb32461013469ad.png";